import React, { useEffect, createElement } from 'react';
interface MetaPixelProps {
  pixelId: string;
}
export function MetaPixel({
  pixelId
}: MetaPixelProps) {
  useEffect(() => {
    if (!pixelId || typeof window === 'undefined') return;
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize the fbq queue (Meta Pixel bootstrap) without relying on an
    // existing <script> tag in the DOM, which may not exist in a sandboxed
    // preview and causes "Cannot read properties of undefined (reading 'parentNode')".
    const w = window as any;
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    // Safely inject the Facebook events script.
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.getElementsByTagName('script')[0] || document.head || document.body;
    if (target && target.parentNode) {
      target.parentNode.insertBefore(script, target);
    } else {
      ;
      (document.head || document.documentElement).appendChild(script);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, [pixelId]);
  return <noscript data-id="element-3">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} alt="" data-id="element-4" />
    </noscript>;
}